<p-tabView orientation="right" (onChange)="selectTab($event)" [activeIndex]="index">
    <p-tabPanel header="Budgets">
        <ng-template pTemplate="content">
            <acabim-datatable
                #dataTable
                [dataSources]="dataSources"
                hasDetailView="true"
                (showDetail)="toggleBudgetStatus(true)"></acabim-datatable>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="close()">Cancel</button>
                <button (click)="addBudget()" class="cas-button-action cas-button-right">Add</button>
            </div>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Expenditures">
        <ng-template pTemplate="content">
            <acabim-datatable
                #expenditureTable
                [dataSources]="expenditureDataSources"
                hasDetailView="true"
                (showDetail)="toggleExpenditureStatus(true)"></acabim-datatable>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="close()">Cancel</button>
                <button (click)="addExpenditure()" class="cas-button-action cas-button-right">Add</button>
            </div>
        </ng-template>
    </p-tabPanel>
</p-tabView>

<ng-template [ngIf]="showModal">
    <acabim-modal
        [display]="true"
        (status)="toggleModalStatus($event)"
        [title]="modalTitle"
        [subtitle]="ltmItem?.maintenance_type_name"
        [overflow]="true"
        [width]="'60vw'"
        [fixHeight]="'60vh'">
        <acabim-admin-edit-details
            [detailData]="{model: _currentSelection, range: {before:20, after: 50}, parent: ltmItem}"
            [type]="type"
            [itemId]="_currentGUID"
            (closeModal)="modalCloseEvent($event)"></acabim-admin-edit-details>
    </acabim-modal>
</ng-template>
<p-toast position="center"></p-toast>
